import { apiClient, handleResp } from './utils';

export default {
  doModeratorRequest(data) {
    return handleResp(
      apiClient().post('/request_moderator', {
        moderator: data,
      }),
    );
  },
};
